module.exports = __webpack_public_path__ + "r-c-bg2.png?b5399415a5da9ac1024978a37e02ad9d";


//////////////////
// WEBPACK FOOTER
// ./static/images/r-c-bg2.png
// module id = 68
// module chunks = 26